"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
var _reactI18next = require("react-i18next");
var _store = require("../../redux/store");
var _deliveryDetailsSlice = require("../../redux/deliveryDetailsSlice");
var _orderSlice = require("../../redux/orderSlice");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _adyenWeb = _interopRequireDefault(require("@adyen/adyen-web"));
var _createPaymentSession = _interopRequireDefault(require("../../api/Payment/createPaymentSession"));
var _offerSlice = require("../../redux/offerSlice");
var _useScriptHook = _interopRequireDefault(require("../../util/useScriptHook"));
var _paymentMethodHelper = require("../../util/paymentMethodHelper");
var _Checkbox = _interopRequireDefault(require("../Checkbox"));
var _PaymentStyled = require("../Payment/PaymentStyled");
var _validators = require("../DeliveryDetails/RecipientForm/validators");
var _publisherConfigSlice = require("../../redux/publisherConfigSlice");
var _eventDispatcher = _interopRequireWildcard(require("../../util/eventDispatcher"));
var _AdyenStyled = _interopRequireDefault(require("./AdyenStyled"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _getAdyenConfig = require("./util/getAdyenConfig");
var _defaultAdyenTranslations = _interopRequireDefault(require("./util/defaultAdyenTranslations"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// eslint-disable-next-line react/no-deprecated

const Adyen = _ref => {
  let {
    onSubmit,
    isMyAccount,
    selectPaymentMethod,
    isPayPalAvailable,
    getDropIn,
    onAdditionalDetails
  } = _ref;
  const order = (0, _store.useAppSelector)(_orderSlice.selectOnlyOrder);
  const offer = (0, _store.useAppSelector)(_offerSlice.selectOnlyOffer);
  const termsUrl = (0, _store.useAppSelector)(_publisherConfigSlice.selectTermsUrl);
  const {
    id: orderId,
    buyAsAGift,
    discount,
    totalPrice,
    offerId,
    priceBreakdown: {
      discountAmount
    }
  } = order;
  const {
    adyenConfiguration,
    paymentMethods: publisherPaymentMethods,
    visiblePaymentMethods
  } = (0, _store.useAppSelector)(state => state.publisherConfig);
  const [isLoading, setIsLoading] = (0, _react.useState)(true);
  const {
    selectedPaymentMethod
  } = (0, _store.useAppSelector)(state => state.paymentMethods);
  const selectedPaymentMethodRef = (0, _react.useRef)(selectedPaymentMethod);
  const deliveryDetails = (0, _store.useAppSelector)(_deliveryDetailsSlice.selectDeliveryDetails);
  const deliveryDetailsRef = (0, _react.useRef)(null);
  const buyAsAGiftRef = (0, _react.useRef)(buyAsAGift || null);
  (0, _react.useEffect)(() => {
    deliveryDetailsRef.current = deliveryDetails;
    buyAsAGiftRef.current = buyAsAGift;
  }, [deliveryDetails, buyAsAGift]);
  (0, _react.useEffect)(() => {
    selectedPaymentMethodRef.current = selectedPaymentMethod;
  }, [selectedPaymentMethod]);
  const standardPaymentMethodsRef = (0, _react.useRef)(null);
  const bankPaymentMethodsRef = (0, _react.useRef)(null);
  const [standardDropInInstance, setStandardDropInInstance] = (0, _react.useState)(null);
  const [bankDropInInstance, setBankDropInInstance] = (0, _react.useState)(null);
  const [standardPaymentSession, setStandardPaymentSession] = (0, _react.useState)(false);
  const [standardSessionError, setStandardSessionError] = (0, _react.useState)(null);
  const [bankSessionError, setBankSessionError] = (0, _react.useState)(null);
  const [noPaymentMethods, setNoPaymentMethods] = (0, _react.useState)(false);
  const [shouldFadeOutStandardDropIn, setShouldFadeOutStandardDropIn] = (0, _react.useState)(false);
  const [shouldFadeOutBankDropIn, setShouldFadeOutBankDropIn] = (0, _react.useState)(false);
  const [shouldHideStandardDropIn, setShouldHideStandardDropIn] = (0, _react.useState)(false);
  const [shouldHideBankDropIn, setShouldHideBankDropIn] = (0, _react.useState)(false);
  (0, _useScriptHook.default)('https://pay.google.com/gp/p/js/pay.js');
  const {
    t,
    i18n
  } = (0, _reactI18next.useTranslation)();
  const dispatch = (0, _store.useAppDispatch)();
  const getBankCopy = () => {
    const isFree = totalPrice === 0;
    const isSubscription = (offerId === null || offerId === void 0 ? void 0 : offerId.charAt(0)) === 'S';
    if (isMyAccount || isFree && isSubscription) {
      // TODO: add link to T&C
      return t('offer-bank-consent-copy.free-subscription', 'By ticking this, you agree to the Terms and Conditions of our service. Your account will be charged €0.10 for authentication purposes. This amount will be refunded once the transaction is completed. Your account will be charged on a recurring basis for the full subscription amount. Your subscription will continue until you cancel.');
    }
    if (isSubscription) {
      // TODO: add link to T&C
      return t('offer-bank-consent-copy.paid-subscription', 'By ticking this, you agree to the Terms and Conditions of our service. Your account will be charged on a recurring basis for the full subscription amount. Your subscription will continue until you cancel.');
    }
    return t(
    // TODO: add link to T&C
    'offer-bank-consent-copy.paid-not-subscription', 'By ticking this, you agree to the Terms and Conditions of our service.');
  };
  const addLegalCheckboxForPaymentMethod = function (methodName) {
    let type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'standard';
    const parentEl = document.querySelector(".adyen-checkout__payment-method--".concat(methodName));
    const checkbox = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Checkbox.default, {
      className: "adyen-checkout__bank-checkbox checkbox-".concat(methodName),
      checked: false,
      onClickFn: (e, _, setIsChecked) => {
        e.target.parentElement.classList.remove('adyen-checkout__bank-checkbox--error');
        setIsChecked(!e.target.checked);
      },
      termsUrl: termsUrl,
      children: type === 'bank' ? getBankCopy() : (0, _paymentMethodHelper.getStandardCopy)(isMyAccount, offer, order, deliveryDetails === null || deliveryDetails === void 0 ? void 0 : deliveryDetails.isGift)
    });
    if (parentEl) {
      const paymentDetailsWrapper = parentEl.querySelector(".adyen-checkout__payment-method__details");
      const doesCheckboxExist = document.querySelector(".checkbox-".concat(methodName));
      if (!doesCheckboxExist) {
        const checkboxWrapper = document.createElement('div');
        checkboxWrapper.classList.add('checkbox-wrapper');
        (0, _reactDom.render)(checkbox, checkboxWrapper);
        parentEl.insertBefore(checkboxWrapper, paymentDetailsWrapper);
      }
    }
  };
  const showAdditionalText = () => {
    if (bankPaymentMethodsRef !== null && bankPaymentMethodsRef !== void 0 && bankPaymentMethodsRef.current) {
      _paymentMethodHelper.bankPaymentMethods.forEach(method => addLegalCheckboxForPaymentMethod(method, 'bank'));
    }
    if (standardPaymentMethodsRef !== null && standardPaymentMethodsRef !== void 0 && standardPaymentMethodsRef.current) {
      _paymentMethodHelper.standardPaymentMethods.forEach(method => addLegalCheckboxForPaymentMethod(method));
    }
  };
  const onSelect = async _ref2 => {
    let {
      type
    } = _ref2;
    return selectPaymentMethod(_paymentMethodHelper.bankPaymentMethodsMapper[type] || type);
  };
  const mountStandardDropIn = adyenCheckout => {
    if (standardPaymentMethodsRef !== null && standardPaymentMethodsRef !== void 0 && standardPaymentMethodsRef.current) {
      const dropin = adyenCheckout.create('dropin', {
        onSelect,
        openFirstPaymentMethod: (adyenConfiguration === null || adyenConfiguration === void 0 ? void 0 : adyenConfiguration.openFirstPaymentMethod) == null ? !window.matchMedia('(max-width:991px)').matches : adyenConfiguration === null || adyenConfiguration === void 0 ? void 0 : adyenConfiguration.openFirstPaymentMethod,
        onReady: showAdditionalText
      });
      dropin.mount(standardPaymentMethodsRef.current);
      setStandardDropInInstance(dropin);
      getDropIn(dropin, _paymentMethodHelper.STANDARD_PAYMENT_METHODS);
    }
  };
  const mountBankDropIn = adyenCheckout => {
    if (bankPaymentMethodsRef !== null && bankPaymentMethodsRef !== void 0 && bankPaymentMethodsRef.current) {
      const dropin = adyenCheckout.create('dropin', {
        onSelect,
        onReady: showAdditionalText,
        openFirstPaymentMethod: false
      });
      dropin.mount(bankPaymentMethodsRef.current);
      setBankDropInInstance(dropin);
      getDropIn(dropin, _paymentMethodHelper.BANK_PAYMENT_METHODS);
    }
  };
  const onError = _ref3 => {
    let {
      error,
      fieldType
    } = _ref3;
    (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_ADYEN_ERROR, {
      error,
      fieldType
    });
  };
  const handleDeliveryDetails = async () => {
    const {
      isGift
    } = deliveryDetailsRef.current;
    if (isGift) {
      const areDeliveryDetailsValid = (0, _validators.validateDeliveryDetailsForm)();
      if (!areDeliveryDetailsValid) {
        return false;
      }
      const {
        recipientEmail,
        deliveryDate,
        deliveryTime,
        message
      } = deliveryDetailsRef.current;
      await dispatch((0, _orderSlice.fetchUpdateOrder)({
        id: orderId,
        payload: {
          buyAsAGift: true,
          deliveryDetails: {
            recipientEmail: recipientEmail.value,
            deliveryDate: new Date("".concat(deliveryDate.value, "T").concat(deliveryTime.value)).valueOf() / 1000,
            personalNote: message.value
          }
        }
      })).unwrap().catch(err => {
        throw new Error(err);
      });
      return true;
    }
    if (buyAsAGiftRef.current && !isGift) {
      await dispatch((0, _orderSlice.fetchUpdateOrder)({
        id: orderId,
        payload: {
          buyAsAGift: false
        }
      })).unwrap().catch(err => {
        throw new Error(err);
      });
      return true;
    }
    return true;
  };
  const isCheckboxChecked = methodName => {
    var _selectedPaymentMetho, _checkbox;
    const isBancontactCard = (selectedPaymentMethodRef === null || selectedPaymentMethodRef === void 0 || (_selectedPaymentMetho = selectedPaymentMethodRef.current) === null || _selectedPaymentMetho === void 0 ? void 0 : _selectedPaymentMetho.methodName) === 'bancontact_card';
    let checkbox = document.querySelector(".checkbox-".concat(methodName));

    // condition below needs to be verified when new 'scheme' is added
    if (methodName === 'scheme') {
      checkbox = document.querySelector(".checkbox-".concat(isBancontactCard ? 'bcmc' : 'card'));
    }
    if (!((_checkbox = checkbox) !== null && _checkbox !== void 0 && _checkbox.checked)) {
      checkbox.classList.add('adyen-checkout__bank-checkbox--error');
      return false;
    }
    return true;
  };
  const createDropInInstance = async (_ref4, type) => {
    var _paymentMethods$find, _paymentMethods$find2, _adyenConfiguration$p, _adyenConfiguration$p2, _adyenConfiguration$p3, _adyenConfiguration$p4, _adyenConfiguration$p5;
    let {
      id,
      sessionData,
      shopperStatement: merchantName,
      amount,
      countryCode,
      paymentMethods
    } = _ref4;
    const amountObj = {
      amount,
      countryCode
    };
    const applePayConfigurationObj = paymentMethods && ((_paymentMethods$find = paymentMethods.find(item => item.type === 'applepay')) === null || _paymentMethods$find === void 0 ? void 0 : _paymentMethods$find.configuration);
    const googlePayConfigurationObj = paymentMethods && ((_paymentMethods$find2 = paymentMethods.find(item => item.type === 'googlepay')) === null || _paymentMethods$find2 === void 0 ? void 0 : _paymentMethods$find2.configuration);
    const configuration = {
      locale: (adyenConfiguration === null || adyenConfiguration === void 0 ? void 0 : adyenConfiguration.locale) || (i18n === null || i18n === void 0 ? void 0 : i18n.language) || 'en-US',
      translations: {
        ..._defaultAdyenTranslations.default,
        ...(adyenConfiguration === null || adyenConfiguration === void 0 ? void 0 : adyenConfiguration.translations)
      },
      environment: (0, _getAdyenConfig.getAdyenEnv)(),
      analytics: (adyenConfiguration === null || adyenConfiguration === void 0 ? void 0 : adyenConfiguration.analytics) || {
        enabled: true //  analytics data for Adyen
      },
      setStatusAutomatically: false,
      session: {
        id,
        sessionData
      },
      clientKey: (0, _getAdyenConfig.getAdyenClientKey)(),
      onSubmit: async (state, component) => {
        const {
          data: {
            paymentMethod
          }
        } = state;
        const methodName = paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type;
        if (!isCheckboxChecked(methodName)) {
          return false;
        }
        component.setStatus('loading');
        const areDeliveryDetailsValid = await handleDeliveryDetails();
        if (!areDeliveryDetailsValid) {
          component.setStatus('ready');
          return false;
        }
        if (type === _paymentMethodHelper.BANK_PAYMENT_METHODS) {
          setShouldFadeOutStandardDropIn(true);
        } else {
          setShouldFadeOutBankDropIn(true);
        }
        return onSubmit(state, component);
      },
      onActionHandled: () => {
        if (type === _paymentMethodHelper.BANK_PAYMENT_METHODS) {
          setShouldHideStandardDropIn(true);
        } else {
          setShouldHideBankDropIn(true);
        }
      },
      onAdditionalDetails,
      onError,
      paymentMethodsConfiguration: {
        card: {
          hasHolderName: true,
          holderNameRequired: true,
          ...(adyenConfiguration === null || adyenConfiguration === void 0 || (_adyenConfiguration$p = adyenConfiguration.paymentMethodsConfiguration) === null || _adyenConfiguration$p === void 0 ? void 0 : _adyenConfiguration$p.card)
        },
        applepay: {
          onClick: async resolve => {
            if (!isCheckboxChecked('applepay')) {
              return;
            }
            const areDeliveryDetailsValid = await handleDeliveryDetails();
            if (!areDeliveryDetailsValid) {
              return;
            }
            resolve();
          },
          ...amountObj,
          ...(applePayConfigurationObj && {
            configuration: {
              merchantName,
              merchantId: applePayConfigurationObj.merchantId
            }
          }),
          ...(adyenConfiguration === null || adyenConfiguration === void 0 || (_adyenConfiguration$p2 = adyenConfiguration.paymentMethodsConfiguration) === null || _adyenConfiguration$p2 === void 0 ? void 0 : _adyenConfiguration$p2.applePay)
        },
        googlepay: {
          onClick: async resolve => {
            if (!isCheckboxChecked('googlepay')) {
              return;
            }
            const areDeliveryDetailsValid = await handleDeliveryDetails();
            if (!areDeliveryDetailsValid) {
              return;
            }
            resolve();
          },
          environment: (0, _getAdyenConfig.getGooglePayEnv)(),
          ...(googlePayConfigurationObj && {
            configuration: {
              merchantName,
              gatewayMerchantId: googlePayConfigurationObj.gatewayMerchantId,
              merchantId: googlePayConfigurationObj.merchantId
            }
          }),
          ...(adyenConfiguration === null || adyenConfiguration === void 0 || (_adyenConfiguration$p3 = adyenConfiguration.paymentMethodsConfiguration) === null || _adyenConfiguration$p3 === void 0 ? void 0 : _adyenConfiguration$p3.googlePay),
          ...amountObj
        },
        ideal: {
          ...(adyenConfiguration === null || adyenConfiguration === void 0 || (_adyenConfiguration$p4 = adyenConfiguration.paymentMethodsConfiguration) === null || _adyenConfiguration$p4 === void 0 ? void 0 : _adyenConfiguration$p4.ideal)
        },
        bcmc: {
          ...(adyenConfiguration === null || adyenConfiguration === void 0 || (_adyenConfiguration$p5 = adyenConfiguration.paymentMethodsConfiguration) === null || _adyenConfiguration$p5 === void 0 ? void 0 : _adyenConfiguration$p5.bancontactCard),
          hasHolderName: true,
          holderNameRequired: true,
          positionHolderNameOnTop: true
        }
      }
    };
    const adyenCheckout = await (0, _adyenWeb.default)(configuration);
    if (type === _paymentMethodHelper.BANK_PAYMENT_METHODS) {
      mountBankDropIn(adyenCheckout);
      setIsLoading(false);
      return;
    }
    mountStandardDropIn(adyenCheckout);
    setIsLoading(false);
  };
  const createSession = async paymentMethodsType => {
    try {
      const response = await (0, _createPaymentSession.default)(paymentMethodsType, visiblePaymentMethods, isMyAccount);
      if (response !== null && response !== void 0 && response.id) {
        createDropInInstance(response, paymentMethodsType);
      }
    } catch (err) {
      if (paymentMethodsType === _paymentMethodHelper.BANK_PAYMENT_METHODS) {
        setBankSessionError(err.message);
      } else {
        setStandardSessionError(err.message);
      }
      setIsLoading(false);
    }
  };
  const generateDropIns = () => {
    const availablePaymentMethods = (0, _paymentMethodHelper.getAvailablePaymentMethods)(publisherPaymentMethods, visiblePaymentMethods);
    if (!availablePaymentMethods.length) {
      setNoPaymentMethods(true);
      setIsLoading(false);
      return;
    }
    if (isMyAccount || totalPrice === 0) {
      const shouldCreateStandardPaymentSession = availablePaymentMethods.some(_ref5 => {
        let {
          methodName
        } = _ref5;
        return !_paymentMethodHelper.bankPaymentMethods.includes(methodName);
      });
      if (shouldCreateStandardPaymentSession) {
        setStandardPaymentSession(true);
        createSession(_paymentMethodHelper.STANDARD_PAYMENT_METHODS);
      }
      const shouldCreateBankPaymentSession = availablePaymentMethods.some(_ref6 => {
        let {
          methodName
        } = _ref6;
        return _paymentMethodHelper.bankPaymentMethods.includes(methodName);
      });
      if (shouldCreateBankPaymentSession) {
        createSession(_paymentMethodHelper.BANK_PAYMENT_METHODS);
      }
    } else {
      createSession();
    }
  };
  (0, _react.useEffect)(() => {
    generateDropIns();
    return () => {
      setStandardDropInInstance(null);
      setBankDropInInstance(null);
    };
  }, []);
  const closeBank = (0, _react.useCallback)(() => {
    if (bankDropInInstance) {
      bankDropInInstance.closeActivePaymentMethod();
    }
  }, [bankDropInInstance]);
  const closeStandard = (0, _react.useCallback)(() => {
    if (standardDropInInstance) {
      standardDropInInstance.closeActivePaymentMethod();
    }
  }, [standardDropInInstance]);
  const recreateDropIn = () => {
    // recreate Adyen Instance if coupon was applied
    bankPaymentMethodsRef.current.removeEventListener('click', closeStandard);
    standardPaymentMethodsRef.current.removeEventListener('click', closeBank);
    if (standardDropInInstance) {
      standardDropInInstance.unmount();
      setStandardDropInInstance(null);
      getDropIn(null, _paymentMethodHelper.STANDARD_PAYMENT_METHODS);
    }
    if (bankDropInInstance) {
      bankDropInInstance.unmount();
      setBankDropInInstance(null);
      getDropIn(null, _paymentMethodHelper.BANK_PAYMENT_METHODS);
    }
    setIsLoading(true);
    generateDropIns();
  };
  const isDropInPresent = standardDropInInstance || bankDropInInstance;
  (0, _react.useEffect)(() => {
    if (bankDropInInstance && standardDropInInstance) {
      standardPaymentMethodsRef.current.addEventListener('click', closeBank);
      bankPaymentMethodsRef.current.addEventListener('click', closeStandard);
    }
  }, [standardDropInInstance, bankDropInInstance]);
  (0, _react.useEffect)(() => {
    if (isDropInPresent && discount !== null && discount !== void 0 && discount.applied) {
      recreateDropIn();
    }
  }, [discount.applied, discount.type, discountAmount]);
  (0, _react.useEffect)(() => {
    if (isDropInPresent) {
      recreateDropIn();
    }
  }, [i18n.language, deliveryDetails === null || deliveryDetails === void 0 ? void 0 : deliveryDetails.isGift]);
  (0, _react.useEffect)(() => {
    if ((selectedPaymentMethod === null || selectedPaymentMethod === void 0 ? void 0 : selectedPaymentMethod.methodName) === 'paypal') {
      if (standardDropInInstance) standardDropInInstance.closeActivePaymentMethod();
      if (bankDropInInstance) bankDropInInstance.closeActivePaymentMethod();
    }
  }, [selectedPaymentMethod]);
  if (noPaymentMethods) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_PaymentStyled.PaymentErrorStyled, {
      children: t('payment-methods.error.not-available', 'Payment methods not available')
    });
  }
  const shouldShowSessionError = standardSessionError && bankSessionError || bankSessionError && !standardPaymentSession;
  if (shouldShowSessionError && !isPayPalAvailable) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_PaymentStyled.PaymentErrorStyled, {
      children: bankSessionError
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_AdyenStyled.default, {
    isMyAccount: true,
    isAdditionalPayment: isPayPalAvailable,
    children: [isLoading && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      ref: standardPaymentMethodsRef,
      style: {
        ...(shouldHideStandardDropIn && {
          display: 'none'
        }),
        ...(shouldFadeOutStandardDropIn && {
          opacity: '0.2',
          pointerEvents: 'none'
        })
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      ref: bankPaymentMethodsRef,
      style: {
        ...(shouldHideBankDropIn && {
          display: 'none'
        }),
        ...(shouldFadeOutBankDropIn && {
          opacity: '0.2',
          pointerEvents: 'none'
        })
      }
    })]
  });
};
Adyen.propTypes = {
  onSubmit: _propTypes.default.func.isRequired,
  isMyAccount: _propTypes.default.bool,
  selectPaymentMethod: _propTypes.default.func.isRequired,
  isPayPalAvailable: _propTypes.default.bool.isRequired,
  getDropIn: _propTypes.default.func.isRequired,
  onAdditionalDetails: _propTypes.default.func.isRequired
};
Adyen.defaultProps = {
  isMyAccount: false
};
var _default = exports.default = Adyen;